import { LinkWithIconProps } from '@repo/ui/src/components/Navigation/_LinkGroup';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';
import Image from '@repo/ui/src/components/Image/New';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  socialLinks?: {
    title?: string;
    links?: Array<LinkWithIconProps>;
  };
  className?: string;
}
const SocialLinks = ({ socialLinks, className }: Props) => {
  if (socialLinks?.links?.length === 0) return null;

  return (
    <div className={classNames('tw-gap-6 tw-flex tw-flex-col tw-pt-5', className)}>
      {socialLinks?.title && (
        <h5 className="tra-text-web-utl-button-m tw-text-neutral-500 tw-grid">
          {socialLinks.title}
        </h5>
      )}
      <div className="tw-flex tw-flex-row tw-gap-3">
        {socialLinks?.links?.map(
          ({ link, externalLink, isExternal, noFollow, noIndex, imageContent, anchorTag }, i) => (
            <Anchor
              key={i}
              link={link}
              externalLink={externalLink}
              isExternal={isExternal}
              noFollow={noFollow}
              noIndex={noIndex}
              anchorTag={anchorTag}
            >
              {imageContent.static ? (
                <img
                  src={buildImageSrc(imageContent)}
                  alt={imageContent?.image?.accessibilityLabel}
                />
              ) : (
                <Image
                  src={buildImageSrc(imageContent)}
                  alt={imageContent?.image?.accessibilityLabel}
                  width={24}
                  height={24}
                />
              )}
            </Anchor>
          ),
        )}
      </div>
    </div>
  );
};

export default SocialLinks;
